type TeceoSelectConfig = {
  variant: 'outlined';
  fullWidth: boolean;
  margin: 'dense';
  formControlProps: { size: 'small' };
};

const teceoSelectConfig: TeceoSelectConfig = {
  variant: 'outlined',
  fullWidth: true,
  margin: 'dense',
  formControlProps: { size: 'small' },
};

export default teceoSelectConfig;
